import { useNavigate } from "react-router-dom";
import { ArrowRight, FileBarChart2 } from "lucide-react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const PREVIEW_DATA = [
  { name: "Investigative", value: 35, color: "#0D9488" },
  { name: "Social", value: 25, color: "#10B981" },
  { name: "Enterprising", value: 22, color: "#F59E0B" },
  { name: "Realistic", value: 18, color: "#2563EB" },
];

export default function SampleReportTeaser() {
  const navigate = useNavigate();
  return (
    <section className="bg-white py-16 px-6 border-b border-slate-100" data-testid="sample-report-teaser-section">
      <div className="max-w-5xl mx-auto rounded-2xl border border-slate-200 bg-gradient-to-br from-indigo-50 via-white to-amber-50 p-6 sm:p-10 grid sm:grid-cols-[auto_1fr_auto] gap-8 items-center" data-testid="sample-report-teaser-card">
        <div className="relative h-28 w-28 mx-auto shrink-0">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie data={PREVIEW_DATA} dataKey="value" innerRadius="62%" outerRadius="98%" paddingAngle={2} isAnimationActive animationDuration={900}>
                {PREVIEW_DATA.map((d, i) => <Cell key={i} fill={d.color} stroke="none" />)}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span className="text-lg font-bold font-mono text-slate-800">78%</span>
            <span className="text-[9px] text-slate-400">Fit Score</span>
          </div>
        </div>
        <div>
          <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-indigo-600 bg-indigo-100 rounded-full px-3 py-1 mb-3" data-testid="sample-report-teaser-badge">
            Real Above-Average Profile Preview
          </span>
          <h3 className="font-heading text-xl sm:text-2xl font-bold text-slate-900 mb-2">
            Curious what your full CareerStudy360 report will actually look like?
          </h3>
          <p className="text-sm text-slate-500 leading-relaxed max-w-xl">
            Explore a full, real sample report generated for "Manisha" — a relatable, above-average student profile —
            complete with archetype cards, donut charts and career matches, before you take the assessment yourself.
          </p>
        </div>
        <button
          type="button"
          data-testid="explore-sample-report-button"
          onClick={() => navigate("/sample-report")}
          className="inline-flex items-center gap-2 rounded-full bg-indigo-600 hover:bg-indigo-700 text-white px-6 h-12 text-sm font-semibold transition-colors shrink-0 justify-self-start sm:justify-self-end whitespace-nowrap"
        >
          <FileBarChart2 className="h-4 w-4" /> Explore Full Sample Report <ArrowRight className="h-4 w-4" />
        </button>
      </div>
    </section>
  );
}
